import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledTag = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e2b3n8t1"
})(_ref => {
  let {
    theme,
    backgroundColor,
    deleteIconSize,
    deleteIconColor,
    hasDeleteIcon
  } = _ref;
  return {
    color: theme.customColors.grey[700],
    display: 'flex',
    alignItems: 'center',
    height: '20px',
    margin: '2px',
    backgroundColor: backgroundColor || '#F2F2F2',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: hasDeleteIcon ? '2px 8px 2px 12px' : '2.5px 4px',
    lineHeight: '20px',
    fontSize: '12px',
    outline: '0',
    overflow: 'hidden',
    '& span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& svg': {
      width: deleteIconSize,
      height: deleteIconSize,
      '& path': {
        fill: deleteIconColor
      }
    },
    '& .MuiButtonBase-root': {
      '& i': {
        color: theme.customColors.grey[800]
      }
    }
  };
}, "");
const StyledAdamTag = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e2b3n8t0"
})(_ref2 => {
  let {
    theme,
    sx
  } = _ref2;
  return _objectSpread2({
    color: theme.customColors.white,
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '22px',
    background: '#95DAD6',
    borderRadius: '20px',
    boxSizing: 'border-box',
    padding: '4px 8px',
    outline: '0',
    overflow: 'hidden',
    fontSize: '16px'
  }, sx);
}, "");
export { StyledAdamTag, StyledTag };